import type { EmailThreadLinkedPolicyDto } from 'korint-sdk';

type Policy = EmailThreadLinkedPolicyDto;

export type PolicyLinkChange = { attached: Policy[]; detached: Policy[] };

const without = (policies: Policy[], others: Policy[]) =>
  policies.filter(({ id }) => !others.some(other => other.id === id));

export const linksAfter = (links: Policy[], { attached, detached }: PolicyLinkChange) => [
  ...without(links, detached),
  ...without(attached, links),
];
